import React, { FunctionComponent } from "react";

export type LoadingMenuItemComponentProps = {
    text: string | undefined;
};

export const LoadingMenuItemComponent: FunctionComponent<LoadingMenuItemComponentProps> = ({ text = "" }) => (
    <div className="loading-menu-item-component">
        {text}
    </div>
);
